import { jsx } from "react/jsx-runtime";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { validateTidalLicense } from "../../base/index.js";
function ArrowDownward(props) {
  return /* @__PURE__ */ jsx(
    ArrowDownwardIcon,
    {
      "data-testid": "ArrowDownward",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ArrowDownward",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
ArrowDownward.tidalIconMeta = {
  categories: "arrows",
  name: "ArrowDownward"
};
validateTidalLicense();
export {
  ArrowDownward
};
//# sourceMappingURL=ArrowDownward.js.map
